import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "prop-container"
};
const _hoisted_2 = {
  key: 1,
  class: "confirmation-container"
};
const _hoisted_3 = {
  class: "confirmation-content"
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  style: {
    "margin-left": "1.0rem"
  },
  class: "confirmation-tips"
};
const _hoisted_6 = {
  key: 2,
  class: "confirmation-container"
};
const _hoisted_7 = {
  class: "confirmation-content"
};
const _hoisted_8 = {
  key: 0,
  class: "disabled-recovery-price"
};
const _hoisted_9 = {
  style: {
    "margin-left": "1.0rem"
  },
  class: "confirmation-tips"
};
const _hoisted_10 = {
  key: 3
};
const _hoisted_11 = {
  class: "props-name"
};
const _hoisted_12 = {
  key: 0,
  class: "disabled-prop"
};
const _hoisted_13 = {
  key: 1,
  class: "transaction-prop"
};
const _hoisted_14 = {
  key: 2,
  class: "props-times"
};
const _hoisted_15 = {
  class: "props-type"
};
const _hoisted_16 = {
  key: 3,
  class: "props-transaction"
};
const _hoisted_17 = {
  class: "props-price"
};
const _hoisted_18 = {
  key: 0
};
const _hoisted_19 = {
  class: "item-content"
};
const _hoisted_20 = {
  class: "item-content"
};
const _hoisted_21 = {
  class: "item-content"
};
const _hoisted_22 = {
  class: "item-content"
};
const _hoisted_23 = {
  class: "item-name"
};
const _hoisted_24 = {
  class: "item-desc"
};
const _hoisted_25 = {
  class: "prop-source-item"
};
const _hoisted_26 = {
  class: "item-desc"
};
const _hoisted_27 = {
  key: 0
};
const _hoisted_28 = {
  key: 0,
  class: "divider"
};
const _hoisted_29 = {
  key: 0,
  class: "transfer-box"
};
const _hoisted_30 = {
  class: "transfer-item"
};
const _hoisted_31 = {
  class: "transfer-item"
};
const _hoisted_32 = {
  class: "transfer-item"
};
const _hoisted_33 = {
  class: "transfer-box"
};
const _hoisted_34 = {
  class: "transfer-item"
};
const _hoisted_35 = {
  class: "transfer-item"
};
const _hoisted_36 = {
  class: "transfer-item"
};
const _hoisted_37 = ["innerHTML"];
import { ref, computed, onMounted } from 'vue';
import { request } from '@/manager/net_manager';
import { ElIcon, ElInput, ElInputNumber, ElMessage, ElRow } from 'element-plus';
import { Switch, Sell, Right } from '@element-plus/icons-vue';
import store from '@/store';
import { Decimal } from 'decimal.js';
import { calculateMD5, compressImage, inApostleType, isUserType, isValid, parseToCostDesc, propsDefaultImage } from '@/tools/utils';
import 'element-plus/es/components/input-number/style/css';
export default {
  __name: 'PocketPropsCard',
  props: {
    propId: {
      type: [String, Number],
      required: true
    },
    roleId: {
      type: [String, Number, null],
      default: null,
      required: false
    },
    operationEnable: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  emits: ['updateProps'],

  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit; // refs

    const message = ref(null);
    const file = ref(null);
    const md5Value = ref(null);
    const imageInput = ref(null);
    const data = ref(null);
    const recipientId = ref(null);
    const traderId = ref(null);
    const traderInfo = ref(null);
    const quantities = ref(1);
    const adjustPrice = ref(0.0);
    const recoveryMode = ref(false); // computed

    const userType = computed(() => {
      return store.state.user ? parseInt(store.state.user.user_type) : 4;
    });
    const roleArray = computed(() => store.state.role_array ?? []);
    const recipientArray = computed(() => {
      if (!isUserType(userType.value)) return [];
      let buffer = roleArray.value.filter(role => role.id !== props.roleId);
      if (buffer.length === 0) return [];
      return buffer.map(item => {
        return {
          'id': item['id'],
          'nickname': item['nickname']
        };
      });
    });
    const transferEnable = computed(() => {
      if (!data.value) return false;
      if (!data.value.binding_type) return true;
      return data.value.binding_type && data.value.binding_type.id !== 2;
    });
    const enableTransaction = computed(() => {
      if (data.value.binding_type && data.value.binding_type.id === 2) {
        return false;
      }

      if (Object.keys(data.value).length === 0) return true;
      let transaction_history = data.value['transaction_history'];
      if (transaction_history === undefined) return true;
      let active_orders = transaction_history.filter(item => [0, 1, 2].includes(item['status'])); // console.log(JSON.stringify(active_orders))

      return active_orders.length === 0;
    });
    const additionalArray = computed(() => {
      if (!data.value) return [];
      let buffer = [];

      if (data.value?.identified || inApostleType(userType.value)) {
        if (data.value.mysterious_level !== undefined) {
          buffer.push({
            'name': '神秘等级',
            'desc': data.value.mysterious_level
          });
        }

        if (data.value.enchant !== undefined) {
          buffer.push({
            'name': '显露灵能',
            'desc': data.value.enchant ? '是' : '非'
          });
        }

        if (data.value.fortify !== undefined) {
          buffer.push({
            'name': '强化状态',
            'desc': getPropsFortifyDesc(data.value.fortify ?? 0)
          });
        }

        if (data.value.detachable !== undefined) {
          buffer.push({
            'name': '允许拆解',
            'desc': data.value.detachable ? '是' : '非'
          });
        }
      }

      buffer.push({
        'name': '重',
        'desc': data.value.weight ? `${data.value.weight} kg` : '不计'
      });

      if (data.value.binding_type) {
        buffer.push({
          'name': '绑定类型',
          'desc': data.value.binding_type.desc
        });
      } // console.log(JSON.stringify(data.value))


      if (data.value.type.is_stackable || isValid(data.value['times'])) {
        buffer.push({
          'name': '可用次数',
          'desc': data.value['times']
        });
      }

      if (data.value.cooldown) {
        buffer.push({
          'name': '冷却',
          'desc': data.value.cooldown.desc
        });
      }

      if (data.value.timing_type) {
        buffer.push({
          'name': '发动时机',
          'desc': data.value.timing_type.desc
        });
      } // if (data.value.cost) {
      //   buffer.push({
      //     'name': '道具消耗',
      //     'desc': data.value.cost
      //   })
      // }


      return buffer;
    });
    const adjustPriceValue = computed(() => {
      if (!data.value) return 0.0;
      let factor = 0.0;

      switch (data.value.rare_level) {
        case 0:
          factor = 0.05;
          break;

        case 1:
          factor = 0.1;
          break;

        case 2:
          factor = 0.15;
          break;

        case 3:
          factor = 0.2;
          break;

        case 4:
          factor = 0.3;
          break;
      }

      return data.value.price * factor;
    });
    const recoveryPriceValue = computed(() => {
      if (!data.value) return '0.0';
      if (!data.value.type.is_stackable || data.value.times === quantities.value) return data.value.recovery_price.toFixed(1);
      if (data.value.times === 0 || quantities.value === 0) return '0.0';
      return Decimal(data.value.recovery_price.toString()).div(Decimal(data.value.times.toString())).times(Decimal(quantities.value.toString())).toFixed(1);
    }); // functions

    const clickImage = () => {
      if (!inApostleType(userType.value)) return;
      imageInput.value.click();
    };

    const handleInputChange = event => {
      file.value = event.target.files[0];

      if (file.value) {
        compressImage(file.value, 2 * 1024 * 1024, value => {
          file.value = value;
          calculateMD5(file.value, value => {
            // console.log(`md5 = ${value}`)
            md5Value.value = value;
            uploadImage();
          });
        });
      }
    };

    const uploadImage = async () => {
      if (message.value) {
        message.value.close();
      }

      const formData = new FormData();
      formData.append('file', file.value);
      formData.set('name', file.value.name);
      formData.set('path', 'props_images');
      formData.set('md5', md5Value.value);
      formData.set('prop_id', props.propId);
      const headers = {
        'Content-Type': 'multipart/form-data'
      };
      const response = await request('props/role_props/upload_image/', formData, 'UPLOAD', headers); // console.log(`upload_role_props_image ${JSON.stringify(response)}`)

      if (response.code !== 0) {
        message.value = ElMessage.error(response.msg);
        return;
      }

      message.value = ElMessage.success('上传成功');
      emits('updateProps');
      file.value = null;
      md5Value.value = null;
      imageInput.value.value = null;
    };

    const getData = () => {
      request('props/role_props/get/', {
        'prop_id': props.propId
      }, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code === 0) {
          data.value = response.data;

          if (inApostleType(userType.value) && data.value.type.is_stackable) {
            quantities.value = data.value.times;
          }
        }
      });
    };

    const getPropsFortifyDesc = item => {
      switch (item) {
        case 0:
          return '不可强化';

        case 1:
          return '可强化';

        case 2:
          return '仍可强化';

        case 3:
          return '已强化';

        default:
          return '';
      }
    };

    function onTraderChanged(value) {
      traderId.value = value.replace(/\D/g, '');
    }

    function submitTransfer() {
      if (message.value) {
        message.value.close();
      }

      if (!recipientId.value) {
        message.value = ElMessage.error({
          message: '没有选择转移对象',
          duration: 1500
        });
        return;
      }

      let parameters = {
        'prop_id': data.value['id'],
        'recipient_id': recipientId.value
      };

      if (traderInfo.value && adjustPrice.value !== 0) {
        parameters['adjust_price'] = adjustPrice.value;
      }

      request('transaction/role_props/transfer/', parameters, 'POST').then(response => {
        if (response.code !== 0) {
          message.value = ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        } // console.log(JSON.stringify(response))


        store.dispatch('get_roles');

        if (traderInfo.value) {
          traderInfo.value = null;
          message.value = ElMessage.success({
            message: '交易已建立',
            duration: 1500
          });
        } else {
          message.value = ElMessage.success({
            message: '完成转移',
            duration: 1500
          });
        }

        emits('updateProps');
      });
    }

    function applyRecovery() {
      recoveryMode.value = true;

      if (data.value.type.is_stackable) {
        quantities.value = data.value.times;
      }
    }

    function confirmRecoveryProp() {
      if (message.value) {
        message.value.close();
      }

      let parameters = {
        'prop_id': data.value['id']
      };

      if (data.value.type.is_stackable) {
        parameters['quantities'] = quantities.value;
      }

      request('props/role_props/recovery/', parameters, 'POST').then(response => {
        if (response.code !== 0) {
          message.value = ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        } // console.log(JSON.stringify(response))


        store.dispatch('get_roles');
        message.value = ElMessage.success({
          message: '完成回收',
          duration: 1500
        });
        emits('updateProps');
      });
    }

    function submitTrading() {
      if (message.value) {
        message.value.close();
      }

      if (!traderId.value) {
        message.value = ElMessage.error({
          message: '缺乏贸易对象',
          duration: 1500
        });
        return;
      } else if (traderId.value.toString() === props.roleId.toString()) {
        message.value = ElMessage.error({
          message: '无法与自己贸易',
          duration: 1500
        });
        return;
      }

      let buffer = store.state.role_array.map(item => item['id']).filter(id => id === traderId.value);

      if (buffer.length > 0) {
        recipientId.value = buffer[0];
        submitTransfer();
        return;
      }

      let parameters = {
        'trader_id': traderId.value
      };
      request('transaction/get_trader/', parameters, 'POST').then(response => {
        if (response.code !== 0) {
          message.value = ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        } // console.log(JSON.stringify(response))


        traderId.value = null;
        adjustPrice.value = 0.0;
        traderInfo.value = response.data;
      });
    }

    function cancelSubmitTraderOrder() {
      traderInfo.value = null;
    }

    function confirmSubmitTraderOrder() {
      recipientId.value = traderInfo.value.id;
      submitTransfer();
    }

    function getTransactionDesc(item) {
      const status = item.status ?? 0;
      const priceDesc = item['price'].toFixed(1);
      let adjustPriceDesc = Math.abs(item['adjust_price']).toFixed(1);

      if (Math.floor(item['adjust_price'] * 100) === 0) {
        adjustPriceDesc = priceDesc;
      } else {
        let finalPrice = (item.price + item.adjust_price).toFixed(1);
        adjustPriceDesc = item['adjust_price'] > 0 ? ` + ${adjustPriceDesc}` : ` - ${adjustPriceDesc}`;
        adjustPriceDesc = `${finalPrice} (${priceDesc}${adjustPriceDesc})`;
      }

      switch (status) {
        case 0:
        case 1:
          return `<p>
            <strong style="padding: 0 0.3rem">${item['create_time']}</strong>
            发起贸易订单，以
            <strong style="padding: 0 0.3rem">${adjustPriceDesc}</strong>
            的价格售予
            <strong style="padding: 0 0.3rem">${item['buyer']['nickname']}</strong>
            ，接受当前调整？
          </p>`;

        case 2:
          return `<p>
            <strong style="padding: 0 0.3rem">${item['create_time']}</strong>
            发起贸易订单，以
            <strong style="padding: 0 0.3rem">${adjustPriceDesc}</strong>
            的价格售予
            <strong style="padding: 0 0.3rem">${item['buyer']['nickname']}</strong>
            ，等待对方确认
          </p>`;

        case 3:
          return `<p>
            <p style="padding: 0 0.3rem">${item['update_time']}</p>
            完成贸易订单，
            <p style="padding: 0 0.3rem">${item['buyer']['nickname']}</p>
            以
            <p style="padding: 0 0.3rem">${adjustPriceDesc}</p>
            的价格从
            <p style="padding: 0 0.3rem">${item['seller']['nickname']}</p>
            手中购得
          </p>`;

        case 4:
          return `<p>
            <p style="padding: 0 0.3rem">${item['seller']['nickname']}</p>
            于
            <p style="padding: 0 0.3rem">${item['create_time']}</p>
            发起贸易订单，
            <p style="padding: 0 0.3rem">${item['update_time']}</p>
            取消售向
            <p style="padding: 0 0.3rem">${item['buyer']['nickname']}</p>
          </p>`;

        case 5:
          return `<p>
            <p style="padding: 0 0.3rem">${item['seller']['nickname']}</p>
            于
            <p style="padding: 0 0.3rem">${item['create_time']}</p>
            发起贸易订单，
            <p style="padding: 0 0.3rem">${item['update_time']}</p>
            <p style="padding: 0 0.3rem">${item['buyer']['nickname']}</p>
            取消购买
          </p>`;

        case 6:
          return `<p>
            <p style="padding: 0 0.3rem">${item['seller']['nickname']}</p>
            于
            <p style="padding: 0 0.3rem">${item['create_time']}</p>
            发起贸易订单，售向
            <p style="padding: 0 0.3rem">${item['buyer']['nickname']}</p>
            ，在
            <p style="padding: 0 0.3rem">${item['update_time']}</p>
            由雾海关闭贸易
          </p>`;

        default:
          return '';
      }
    }

    function getCancelOrderDesc(item) {
      const status = item.status ?? 0;

      switch (status) {
        case 0:
        case 1:
          return '拒绝';

        case 2:
          return '取消贸易';

        default:
          return '';
      }
    }

    function cancelTraderOrder(item) {
      if (message.value) {
        message.value.close();
      }

      if (!item['id']) {
        message.value = ElMessage.error({
          message: '错误的订单号',
          duration: 1500
        });
        return;
      }

      let parameters = {
        'order_id': item['id']
      };
      request('transaction/role_transaction/cancel/', parameters, 'POST').then(response => {
        if (response.code !== 0) {
          message.value = ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        } // console.log(JSON.stringify(response))


        store.dispatch('get_roles');
        emits('updateProps');
        message.value = ElMessage.info({
          message: '贸易已取消',
          duration: 1500
        });
      });
    }

    function agreeTraderOrder(item) {
      if (message.value) {
        message.value.close();
      }

      if (!Object.keys(item).includes('id')) {
        message.value = ElMessage.error({
          message: '错误的订单号',
          duration: 1500
        });
        return;
      }

      let parameters = {
        'order_id': item['id']
      };
      request('transaction/role_transaction/accept/', parameters, 'POST').then(response => {
        if (response.code !== 0) {
          message.value = ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        } // console.log(JSON.stringify(response))


        store.dispatch('get_roles');
        emits('updateProps');
        message.value = ElMessage.success({
          message: '确认订单',
          duration: 1500
        });
      });
    }

    const setPropEnable = () => {
      if (message.value) {
        message.value.close();
      }

      let parameters = {
        'updates': {
          'id': props.propId,
          'enable': !data.value.enable
        }
      };
      request('props/role_props/update/', parameters, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code !== 0) {
          message.value = ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        emits('updateProps');
        message.value = ElMessage.success({
          message: '完成修改',
          duration: 1500
        });
      });
    };

    const setPropIdentified = () => {
      let parameters = {
        'updates': {
          'id': props.propId,
          'identified': !data.value.identified
        }
      };
      request('props/role_props/update/', parameters, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code !== 0) {
          message.value = ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        emits('updateProps');
        message.value = ElMessage.success({
          message: '完成修改',
          duration: 1500
        });
      });
    };

    const setPropTimes = () => {
      let parameters = {
        'updates': {
          'id': props.propId,
          'times': quantities.value
        }
      };
      request('props/role_props/update/', parameters, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code !== 0) {
          message.value = ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        emits('updateProps');
        message.value = ElMessage.success({
          message: '完成修改',
          duration: 1500
        });
      });
    };

    const setPropDestroyed = () => {
      let parameters = {
        'updates': {
          'id': props.propId,
          'destroyed': true
        }
      };
      request('props/role_props/update/', parameters, 'POST').then(response => {
        if (response.code !== 0) {
          message.value = ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        } // console.log(JSON.stringify(response))
        // store.dispatch('get_roles')


        emits('updateProps');
        message.value = ElMessage.success({
          message: '完成修改',
          duration: 1500
        });
      });
    }; // lifecycle


    onMounted(() => {
      getData();
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_el_image = _resolveComponent("el-image");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      return data.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_unref(inApostleType)(userType.value) ? (_openBlock(), _createElementBlock("input", {
        key: 0,
        type: "file",
        accept: "image/png, image/jpeg",
        style: {
          "display": "none"
        },
        ref_key: "imageInput",
        ref: imageInput,
        onChange: handleInputChange
      }, null, 544)) : _createCommentVNode("", true), traderInfo.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_cache[12] || (_cache[12] = _createElementVNode("text", {
        class: "confirmation-title"
      }, "确认交易信息", -1)), _createVNode(_unref(ElRow), {
        style: {
          "margin-top": "1.0rem",
          "justify-content": "center"
        }
      }, {
        default: _withCtx(() => [_createElementVNode("text", _hoisted_3, [_createTextVNode(" 以 " + _toDisplayString(data.value['price'].toFixed(1)) + "  ", 1), adjustPrice.value !== 0 ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(adjustPrice.value > 0 ? `+ ${adjustPrice.value.toFixed(1)}` : `- ${Math.abs(adjustPrice.value).toFixed(1)}`) + " " + _toDisplayString(`  = ${(data.value.price + adjustPrice.value).toFixed(1)}`), 1)) : _createCommentVNode("", true), _cache[6] || (_cache[6] = _createTextVNode(" 资产点的价格， 贩卖 ", -1)), _createElementVNode("b", null, _toDisplayString(data.value['name']), 1), _cache[7] || (_cache[7] = _createTextVNode(" 给 ", -1)), _createElementVNode("b", null, _toDisplayString(traderInfo.value['nickname']), 1), _cache[8] || (_cache[8] = _createTextVNode(" 吗？ ", -1))])]),
        _: 1
      }), _createVNode(_unref(ElRow), {
        style: {
          "margin-top": "1.0rem",
          "padding": "0 30%",
          "align-items": "center"
        }
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElInputNumber), {
          modelValue: adjustPrice.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => adjustPrice.value = $event),
          min: -adjustPriceValue.value,
          max: adjustPriceValue.value,
          precision: 1,
          step: 0.1,
          placeholder: "调整价格"
        }, null, 8, ["modelValue", "min", "max"]), _createElementVNode("text", _hoisted_5, " 当前道具的价格调整区间：±" + _toDisplayString(adjustPriceValue.value.toFixed(1)), 1)]),
        _: 1
      }), adjustPrice.value !== 0 ? (_openBlock(), _createBlock(_unref(ElRow), {
        key: 0,
        style: {
          "margin-top": "1.0rem",
          "justify-content": "flex-end"
        }
      }, {
        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createElementVNode("text", {
          class: "confirmation-tips"
        }, " tips：道具的估价是固定的，调整金额交易双方可见 ", -1)]))]),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_unref(ElRow), {
        style: {
          "margin-top": "1.0rem",
          "justify-content": "flex-end"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          class: "cancelTraderOrder",
          onClick: cancelSubmitTraderOrder
        }, {
          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode("取消交易", -1)]))]),
          _: 1
        }), _createVNode(_component_el_button, {
          class: "confirmTraderOrder",
          onClick: confirmSubmitTraderOrder
        }, {
          default: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createTextVNode("发起交易", -1)]))]),
          _: 1
        })]),
        _: 1
      })])) : recoveryMode.value ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_cache[18] || (_cache[18] = _createElementVNode("text", {
        class: "confirmation-title"
      }, "确认回收信息", -1)), _createVNode(_unref(ElRow), {
        style: {
          "margin-top": "1.0rem",
          "justify-content": "center"
        }
      }, {
        default: _withCtx(() => [_createElementVNode("text", _hoisted_7, [_cache[13] || (_cache[13] = _createTextVNode(" 确认以  ", -1)), _createElementVNode("span", {
          class: _normalizeClass(!data.value.enable ? 'strikethrough-recovery-price' : 'normal-recovery-price')
        }, _toDisplayString(recoveryPriceValue.value), 3), !data.value.enable ? (_openBlock(), _createElementBlock("span", _hoisted_8, "  " + _toDisplayString((parseFloat(recoveryPriceValue.value) * 0.5).toFixed(1)), 1)) : _createCommentVNode("", true), _cache[14] || (_cache[14] = _createTextVNode("  资产点的价格，进行回收吗？ ", -1))])]),
        _: 1
      }), data.value.type.is_stackable && data.value.times !== 1 ? (_openBlock(), _createBlock(_unref(ElRow), {
        key: 0,
        style: {
          "margin-top": "1.0rem",
          "padding": "0 30%",
          "align-items": "center"
        }
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElInputNumber), {
          modelValue: quantities.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => quantities.value = $event),
          max: data.value.times,
          min: 1
        }, null, 8, ["modelValue", "max"]), _createElementVNode("text", _hoisted_9, " 请选择回收数量（1~" + _toDisplayString(data.value.times) + "） ", 1)]),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_unref(ElRow), {
        style: {
          "margin-top": "1.0rem",
          "justify-content": "flex-end"
        }
      }, {
        default: _withCtx(() => [...(_cache[15] || (_cache[15] = [_createElementVNode("text", {
          class: "confirmation-tips"
        }, " tips：每个角色资产点持有上限为200，请留意资产情况以避免损失 ", -1)]))]),
        _: 1
      }), _createVNode(_unref(ElRow), {
        style: {
          "margin-top": "1.0rem",
          "justify-content": "flex-end"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          class: "cancelTraderOrder",
          onClick: _cache[2] || (_cache[2] = $event => recoveryMode.value = false)
        }, {
          default: _withCtx(() => [...(_cache[16] || (_cache[16] = [_createTextVNode("取消回收", -1)]))]),
          _: 1
        }), _createVNode(_component_el_button, {
          class: "confirmTraderOrder",
          onClick: confirmRecoveryProp
        }, {
          default: _withCtx(() => [...(_cache[17] || (_cache[17] = [_createTextVNode("确认回收", -1)]))]),
          _: 1
        })]),
        _: 1
      })])) : (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(_unref(ElRow), {
        class: "props-core-container"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          offset: 2,
          span: 6
        }, {
          default: _withCtx(() => [_createVNode(_component_el_image, {
            class: "prop-image",
            src: data.value.image && data.value.image.length > 0 ? data.value.image : _unref(propsDefaultImage),
            draggable: "false",
            onClick: clickImage
          }, null, 8, ["src"])]),
          _: 1
        }), _createVNode(_component_el_col, {
          offset: 1,
          span: 13
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElRow), {
            style: {
              "justify-content": "space-between"
            }
          }, {
            default: _withCtx(() => [_createElementVNode("text", _hoisted_11, [_createTextVNode(_toDisplayString(data.value.name) + " ", 1), !data.value.enable ? (_openBlock(), _createElementBlock("span", _hoisted_12, " 【残损】 ")) : _createCommentVNode("", true), data.value.in_transaction ? (_openBlock(), _createElementBlock("span", _hoisted_13, " 【贸易中】 ")) : _createCommentVNode("", true), data.value.type.is_stackable ? (_openBlock(), _createElementBlock("span", _hoisted_14, "  x " + _toDisplayString(data.value.times), 1)) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_15, _toDisplayString(data.value.type.desc) + " / " + _toDisplayString(data.value.tag.desc), 1), _createElementVNode("span", {
              class: _normalizeClass([`rare-${data.value.rare_level}`, 'rare-tag'])
            }, _toDisplayString(data.value.rare_desc), 3), [0, 1, 2].includes(data.value.status) ? (_openBlock(), _createElementBlock("span", _hoisted_16, " 交易中 ")) : _createCommentVNode("", true)]), _unref(isUserType)(userType.value) && data.value.recovery_price !== 0 && __props.operationEnable ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              class: "apply-recovery",
              onClick: applyRecovery
            }, {
              default: _withCtx(() => [...(_cache[19] || (_cache[19] = [_createTextVNode(" 回收道具 ", -1)]))]),
              _: 1
            })) : _createCommentVNode("", true)]),
            _: 1
          }), _createVNode(_unref(ElRow), null, {
            default: _withCtx(() => [_createElementVNode("text", _hoisted_17, " 作价 " + _toDisplayString(parseFloat(data.value.price).toFixed(1)) + " 点  / 回收 " + _toDisplayString(parseFloat(data.value.recovery_price).toFixed(1)) + " 点 ", 1)]),
            _: 1
          }), _cache[24] || (_cache[24] = _createElementVNode("div", {
            style: {
              "height": "1.0rem"
            }
          }, null, -1)), _unref(isValid)(data.value.cost) ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createVNode(_component_el_col, {
            class: "item-row"
          }, {
            default: _withCtx(() => [_cache[20] || (_cache[20] = _createElementVNode("text", {
              class: "item-tag"
            }, "道具消耗", -1)), _createElementVNode("text", _hoisted_19, "    " + _toDisplayString(_unref(parseToCostDesc)(data.value.cost)), 1)]),
            _: 1
          })])) : _createCommentVNode("", true), _createVNode(_component_el_col, {
            class: "item-row"
          }, {
            default: _withCtx(() => [_cache[21] || (_cache[21] = _createElementVNode("text", {
              class: "item-tag"
            }, "形态描述", -1)), _createElementVNode("text", _hoisted_20, "    " + _toDisplayString(data.value['appearance_desc']), 1)]),
            _: 1
          }), _createVNode(_component_el_col, {
            class: "item-row"
          }, {
            default: _withCtx(() => [_cache[22] || (_cache[22] = _createElementVNode("text", {
              class: "item-tag"
            }, "性能描述", -1)), _createElementVNode("text", _hoisted_21, "    " + _toDisplayString(data.value['function_desc']), 1)]),
            _: 1
          }), data.value['deep_desc'] ? (_openBlock(), _createBlock(_component_el_col, {
            key: 1,
            class: "item-row"
          }, {
            default: _withCtx(() => [_cache[23] || (_cache[23] = _createElementVNode("text", {
              class: "item-tag"
            }, "深层信息", -1)), _createElementVNode("text", _hoisted_22, "    " + _toDisplayString(data.value['deep_desc']), 1)]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      }), _createElementVNode("div", null, [_createVNode(_component_el_col, {
        offset: 2,
        span: 20
      }, {
        default: _withCtx(() => [_cache[26] || (_cache[26] = _createElementVNode("div", {
          class: "divider"
        }, null, -1)), _createVNode(_unref(ElRow), {
          class: "prop-additional-container"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(additionalArray.value, item => {
            return _openBlock(), _createElementBlock("div", {
              class: "prop-additional-item",
              key: item.name
            }, [_createElementVNode("text", _hoisted_23, _toDisplayString(item.name), 1), _createElementVNode("text", _hoisted_24, _toDisplayString(item.desc), 1)]);
          }), 128))]),
          _: 1
        }), _createVNode(_unref(ElRow), {
          class: "prop-source-container"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_25, [_createElementVNode("text", _hoisted_26, [_cache[25] || (_cache[25] = _createElementVNode("span", {
            class: "item-name"
          }, "源于", -1)), _createTextVNode(" " + _toDisplayString(data.value.source && data.value.source.length > 0 ? data.value.source : '雾海'), 1)])])]),
          _: 1
        })]),
        _: 1
      })]), _unref(inApostleType)(userType.value) && __props.operationEnable ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_createVNode(_component_el_col, {
        offset: 2,
        span: 20
      }, {
        default: _withCtx(() => [_cache[29] || (_cache[29] = _createElementVNode("div", {
          class: "divider"
        }, null, -1)), _unref(inApostleType)(userType.value) ? (_openBlock(), _createBlock(_unref(ElRow), {
          key: 0,
          class: "operationContainer"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            offset: 0,
            span: 3
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              onClick: setPropIdentified
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(!data.value.identified ? '置已鉴定' : '置未鉴定'), 1)]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            offset: 1,
            span: 3
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              onClick: setPropEnable
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(data.value.enable ? '置不可用' : '置为可用'), 1)]),
              _: 1
            })]),
            _: 1
          }), _withDirectives(_createVNode(_component_el_col, {
            offset: 1,
            span: 5
          }, {
            default: _withCtx(() => [_createVNode(_unref(ElInputNumber), {
              modelValue: quantities.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => quantities.value = $event),
              max: 999,
              min: 1
            }, null, 8, ["modelValue"])]),
            _: 1
          }, 512), [[_vShow, data.value.type.is_stackable]]), _withDirectives(_createVNode(_component_el_col, {
            offset: 1,
            span: 3
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              onClick: setPropTimes
            }, {
              default: _withCtx(() => [...(_cache[27] || (_cache[27] = [_createTextVNode(" 更新可用次数 ", -1)]))]),
              _: 1
            })]),
            _: 1
          }, 512), [[_vShow, data.value.type.is_stackable]]), _createVNode(_component_el_col, {
            offset: data.value.type.is_stackable ? 3 : 13,
            span: 4
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              class: "destroyed",
              onClick: setPropDestroyed
            }, {
              default: _withCtx(() => [...(_cache[28] || (_cache[28] = [_createTextVNode(" 销毁道具 ", -1)]))]),
              _: 1
            })]),
            _: 1
          }, 8, ["offset"])]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      })])) : _createCommentVNode("", true), _unref(isUserType)(userType.value) && __props.operationEnable ? (_openBlock(), _createBlock(_component_el_col, {
        key: 1,
        offset: 2,
        span: 20
      }, {
        default: _withCtx(() => [data.value['transaction_history'] || !data.value.binding_type || data.value.binding_type && data.value.binding_type.id !== 2 ? (_openBlock(), _createElementBlock("div", _hoisted_28)) : _createCommentVNode("", true), enableTransaction.value ? (_openBlock(), _createBlock(_unref(ElRow), {
          key: 1,
          style: {
            "align-items": "center"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            offset: 0,
            span: 11
          }, {
            default: _withCtx(() => [transferEnable.value && recipientArray.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createVNode(_unref(ElIcon), {
              size: 12,
              style: {
                "height": "1.5rem"
              }
            }, {
              default: _withCtx(() => [_createVNode(_unref(Switch))]),
              _: 1
            }), _cache[30] || (_cache[30] = _createElementVNode("text", null, "  转移向    ", -1))]), _createElementVNode("div", _hoisted_31, [_createVNode(_component_el_select, {
              modelValue: recipientId.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => recipientId.value = $event),
              "show-arrow": false,
              clearable: "",
              placeholder: "选择转移对象",
              "popper-class": "commonPopper",
              size: "small"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recipientArray.value, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.nickname,
                  value: item.id
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_32, [_createVNode(_component_el_button, {
              onClick: submitTransfer
            }, {
              default: _withCtx(() => [...(_cache[31] || (_cache[31] = [_createTextVNode(" 执行 ", -1)]))]),
              _: 1
            })])])) : _createCommentVNode("", true)]),
            _: 1
          }), !data.value.binding_type || data.value.binding_type && data.value.binding_type.id === 3 ? (_openBlock(), _createBlock(_component_el_col, {
            key: 0,
            offset: 2,
            span: 11
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [_createVNode(_unref(ElIcon), {
              size: 16,
              style: {
                "height": "1.5rem"
              }
            }, {
              default: _withCtx(() => [_createVNode(_unref(Sell))]),
              _: 1
            }), _cache[32] || (_cache[32] = _createElementVNode("text", null, "  售卖向    ", -1))]), _createElementVNode("div", _hoisted_35, [_createVNode(_unref(ElInput), {
              modelValue: traderId.value,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => traderId.value = $event),
              maxlength: "16",
              placeholder: "目标连接器id",
              round: "",
              type: "text",
              clearable: "",
              onInput: onTraderChanged
            }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_36, [_createVNode(_component_el_button, {
              onClick: submitTrading
            }, {
              default: _withCtx(() => [...(_cache[33] || (_cache[33] = [_createTextVNode(" 执行 ", -1)]))]),
              _: 1
            })])])]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        })) : _createCommentVNode("", true), data.value['transaction_history'] ? (_openBlock(), _createBlock(_unref(ElRow), {
          key: 2,
          class: "transaction-history-container"
        }, {
          default: _withCtx(() => [_cache[35] || (_cache[35] = _createElementVNode("div", {
            class: "divider"
          }, null, -1)), _createVNode(_component_el_col, {
            offset: 0,
            span: 24
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value['transaction_history'], (item, index) => {
              return _openBlock(), _createBlock(_unref(ElRow), {
                key: index,
                class: _normalizeClass(["history-item", [0, 1, 2].includes(item['status']) ? 'active-history-item' : ''])
              }, {
                default: _withCtx(() => [_createVNode(_unref(ElIcon), {
                  size: 12,
                  style: {
                    "display": "flex",
                    "height": "1.8rem",
                    "margin-right": "0.3rem"
                  }
                }, {
                  default: _withCtx(() => [_createVNode(_unref(Right))]),
                  _: 1
                }), _createElementVNode("text", {
                  class: "transaction-desc",
                  innerHTML: getTransactionDesc(item)
                }, null, 8, _hoisted_37), [0, 1, 2].includes(item['status']) ? (_openBlock(), _createBlock(_unref(ElRow), {
                  key: 0
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_button, {
                    onClick: $event => cancelTraderOrder(item),
                    class: "cancelTraderOrder"
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(getCancelOrderDesc(item)), 1)]),
                    _: 2
                  }, 1032, ["onClick"]), item['status'] === 1 ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    onClick: $event => agreeTraderOrder(item),
                    class: "agreeTraderOrder"
                  }, {
                    default: _withCtx(() => [...(_cache[34] || (_cache[34] = [_createTextVNode(" 接受 ", -1)]))]),
                    _: 1
                  }, 8, ["onClick"])) : _createCommentVNode("", true)]),
                  _: 2
                }, 1024)) : _createCommentVNode("", true)]),
                _: 2
              }, 1032, ["class"]);
            }), 128))]),
            _: 1
          })]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      })) : _createCommentVNode("", true)]))])) : _createCommentVNode("", true);
    };
  }

};